var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrailerIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 232 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graph/trailer_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_grey"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,69.2717495 C174.758558,62.5994047 167.916403,58 160,58 C151.107314,58 143.570176,63.8037897 140.969784,71.8301714 L67.4503811,71.8301714 C65.9839696,64.1689057 61.7713753,60.8764913 52.1529842,60.0852461 C47.8707688,60.0852461 30.4864408,60.0852461 1.16226473e-16,60.0852461 L0,0 L232,0 L232,71.8301714 C224.359034,71.8301714 218.826125,71.8301714 215.401274,71.8301714 L215.030216,71.8301714 C212.429824,63.8037897 204.892686,58 196,58 C188.083597,58 181.241442,62.5994047 178,69.2717495 Z",
    id: "Combined-Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 7,
    cx: 160,
    cy: 78,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 7,
    cx: 196,
    cy: 78,
    r: 11.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIconBlack);
export default __webpack_public_path__ + "static/media/trailer_icon_black.59349f512e4d01067ed0a1ad32e99e6b.svg";
export { ForwardRef as ReactComponent };